import {
  Carousel,
  CarouselNext,
  CarouselItem,
  CarouselContent,
  CarouselPrevious,
} from '@design-system/Carousel';
import { Skeleton } from '@design-system/Skeleton';
import { cn } from '@/utils/styles';
  
export const NutritionPageEducationCarouselSkeleton = () => {
  return (
    <Carousel className={cn('w-full relative')}>
      <CarouselContent>
        {Array.from({ length: 10 }).map((_, index) => (
          <CarouselItem
            key={`education-skeleton-${index}`}
            className="max-w-72 min-h-28"
          >
            <div className="p-1 w-full h-full">
              <Skeleton className="size-full" />
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>

      <CarouselPrevious variant="ghost" />
      <CarouselNext variant="ghost" />
    </Carousel>
  );
};